// Loading.tsx
import React from 'react';
import { createPortal } from 'react-dom';
import LoadingOverlay from "react-loading-overlay-ts";
import { ClipLoader } from 'react-spinners';

interface LoadingProps {
  active: boolean;
}

const Loading: React.FC<LoadingProps> = ({ active }) => {
  if (typeof document === 'undefined') return null; // SSR 安全

  return createPortal(
    <LoadingOverlay
  active={active}
  spinner={<ClipLoader color="#2563EB" size={70} />}
  text="Loading…"
  styles={{
    overlay: (base) => ({
      ...base,
      position: 'fixed',     // 固定在屏幕
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',       // 撑满全屏
      zIndex: 19999,
      background: 'rgba(255, 255, 255, 0.4)',
      display: 'flex',
      alignItems: 'center',  // 垂直居中
      justifyContent: 'center', // 水平居中
    }),
    wrapper: (base) => ({
      ...base,
      display: 'flex',
      flexDirection: 'column', // spinner 上文字下
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',          // 撑满 overlay
    }),
    content: (base) => ({
      ...base,
      margin: 0,
      color: '#2563EB',
      fontSize: '1.3rem',
      fontWeight: 600,
      textAlign: 'center',
    }),
  }}
/>,
    document.body
  );
};

export default Loading;
